import {
  AccordionButton,
  AccordionItem,
  AccordionPanel,
  Box,
  Flex,
  Text,
} from "@chakra-ui/react";
import { Fragment, ReactNode } from "react";

import { NavItem } from "./config";
import { navItemStyles } from "./nav-link";

import { ChevronRightIcon } from "ui/icons";

type NavFolderProps = {
  /** If a folder is active, it means that it contains the current page */
  isActive?: boolean;
  item: NavItem;
  children: ReactNode;
};

export function NavFolder({ isActive, item, children }: NavFolderProps) {
  return (
    <AccordionItem pos="relative" w="100%">
      {({ isExpanded }) => (
        <Fragment>
          <AccordionButton
            borderRadius="md"
            _focusVisible={{
              outline: "none !important",
              boxShadow: "outline",
            }}
          >
            <Flex
              {...navItemStyles}
              align="center"
              borderRadius="md"
              color={isActive ? "text.primary" : "text.secondary"}
              height={{ base: "44px", md: "36px" }}
              px={2}
              whiteSpace="nowrap"
              sx={{ touchAction: "manipulation" }}
              transition="150ms background-color ease-out, 150ms color ease-out"
              _hover={{ bg: "base.background" }}
            >
              <Flex align="center" justify="space-between" flex={1}>
                <Text as="span" fontWeight="medium" lineHeight="20px">
                  {item.label}
                </Text>
                <ChevronRightIcon
                  boxSize={4}
                  transition="transform 0.15s ease-out"
                  transform={isExpanded ? "rotate(90deg)" : "rotate(0deg)"}
                />
              </Flex>
            </Flex>
          </AccordionButton>

          <AccordionPanel>
            <Box as="ul" listStyleType="none">
              {children}
            </Box>
          </AccordionPanel>
        </Fragment>
      )}
    </AccordionItem>
  );
}
